

























import { defineComponent } from '@vue/composition-api'
import BaseLayout from '@/components/_shared/BaseLayout.vue'
import { AboutInfoIntroDatas, AboutInfoListDatas } from '@/model/AboutInfoListDatas'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'AboutContainer',
  components: { BaseLayout },
  setup () {
    return {
      AboutInfoIntroDatas,
      AboutInfoListDatas
    }
  }
})
